import { Box } from "@mui/material";
import { useInViewOnce } from "src/utils/useInViewOnce.js";

/** How far below the viewport a deferred block starts mounting. */
const MOUNT_ROOT_MARGIN = "900px 0px";

/**
 * Defers mounting its children until the placeholder nears the viewport, so a
 * long feed pays load-time cost only for its first screens. The placeholder
 * height keeps the scrollbar stable; the generous root margin mounts content
 * well before it becomes visible.
 *
 * @param {{ minHeight?: number, children: React.ReactNode }} props
 */
const DeferredMount = ({ minHeight = 340, children }) => {
  const [ref, inView] = useInViewOnce({ rootMargin: MOUNT_ROOT_MARGIN });
  return (
    <Box ref={ref} data-testid="deferred-mount" sx={inView ? undefined : { minHeight }}>
      {inView ? children : null}
    </Box>
  );
};

export default DeferredMount;
